import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AccountCreationPrompt = ({ isGuestUser = true, customerEmail }) => {
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(false);

  if (!isGuestUser || isDismissed) {
    return null;
  }

  const handleCreateAccount = () => {
    navigate('/register', { 
      state: { 
        email: customerEmail,
        fromOrderConfirmation: true 
      }
    });
  };

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  return (
    <div className="bg-gradient-to-r from-primary/5 to-accent/5 border border-primary/20 rounded-lg p-6 mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-4 flex-1">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="UserPlus" size={24} className="text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-foreground mb-2">Create Your Account</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Save your order history, track shipments, and enjoy faster checkout for future purchases.
            </p>
            
            {/* Benefits List */}
            <div className="space-y-2 mb-4">
              <div className="flex items-center text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="mr-2 text-success" />
                <span>Track all your orders in one place</span>
              </div>
              <div className="flex items-center text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="mr-2 text-success" />
                <span>Save addresses for faster checkout</span>
              </div>
              <div className="flex items-center text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="mr-2 text-success" />
                <span>Get exclusive offers and early access</span>
              </div>
              <div className="flex items-center text-sm text-muted-foreground">
                <Icon name="Check" size={16} className="mr-2 text-success" />
                <span>Manage your wishlist and preferences</span>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                variant="default"
                onClick={handleCreateAccount}
                iconName="UserPlus"
                iconPosition="left"
              >
                Create Account
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleDismiss}
                className="text-muted-foreground"
              >
                Maybe Later
              </Button>
            </div>
          </div>
        </div>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={handleDismiss}
          className="text-muted-foreground hover:text-foreground"
        >
          <Icon name="X" size={16} />
        </Button>
      </div>
    </div>
  );
};

export default AccountCreationPrompt;